import styled from "styled-components";
import { Link } from "react-router-dom";
import { colorPallet } from "../../../../styles/global";

export const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-decoration: none;
  overflow-wrap: break-word;

  img {
    width: 100%;
    object-fit: cover;
    height: 300px;
    margin-bottom: 15px;
    transform: scale(100%);
  }

  > p {
    font-size: 15px;
    color: ${colorPallet.darkBlue};
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    @media screen and (max-width: 1366px) {
      font-size: 13px;
    }
  }
`;

export const Info = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin: 10px 0;
  overflow-wrap: break-word;
  h1 {
    width: 100%;
    font-weight: 500;
    font-size: 20px;
    color: ${colorPallet.darkBlue};
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;

    @media screen and (max-width: 1366px) {
      font-size: 18px;
    }
  }
  p {
    font-size: 10px;
    font-weight: 500;
    color: ${colorPallet.grey};
  }
`;
